import { useTranslation } from "react-i18next";

export const useMobileTableHeaders = (): string[] => {
    const { t } = useTranslation();

    return [
        t('status'),
        t('opened'),
        t('clicked'),
    ];
};
